import React from 'react';
import { Box, Grid, GridItem, Text, HStack, VStack } from '@chakra-ui/react';
import { MONTH_COLORS, MONTH_NAMES_SHORT } from '../apiConfig';

const MONTHS = Object.entries(MONTH_NAMES_SHORT).sort(([a], [b]) => parseInt(a) - parseInt(b));

const UpkeepMapLegend: React.FC = () => {
    return (
        <Box
            bg="white"
            borderRadius="lg"
            boxShadow="md"
            p={3}
            border="1px solid"
            borderColor="gray.200"
            maxW="340px"
        >
            <Text fontSize="xs" fontWeight="bold" color="gray.600" mb={2}>
                Legend
            </Text>

            {/* Month color grid */}
            <Grid templateColumns="repeat(6, 1fr)" gap={1} mb={3}>
                {MONTHS.map(([val, name]) => (
                    <GridItem key={val}>
                        <VStack spacing={0} align="center">
                            <Box
                                w="20px"
                                h="12px"
                                bg={MONTH_COLORS[val]}
                                borderRadius="sm"
                            />
                            <Text fontSize="9px" color="gray.600" lineHeight="1.2" textAlign="center">
                                {name}
                            </Text>
                        </VStack>
                    </GridItem>
                ))}
            </Grid>

            {/* Legend items */}
            <Box borderTop="1px solid" borderColor="gray.100" pt={2}>
                <VStack spacing={2} align="stretch">
                    {/* Budget per Bulan */}
                    <HStack spacing={2}>
                        <Box flexShrink={0} w="20px" display="flex" justifyContent="center" alignItems="center">
                            <Box
                                w="16px"
                                h="12px"
                                bg="gray.400"
                                borderRadius="sm"
                            />
                        </Box>
                        <Text fontSize="xs" color="gray.600">Budget per Bulan</Text>
                    </HStack>

                    {/* Realisasi >= Budget */}
                    <HStack spacing={2}>
                        <Box flexShrink={0} w="20px" display="flex" justifyContent="center" alignItems="center">
                            <Box
                                w="16px"
                                h="16px"
                                bg="gray.400"
                                borderRadius="full"
                                border="2px solid white"
                                boxShadow="sm"
                            />
                        </Box>
                        <Text fontSize="xs" color="gray.600">Realisasi &ge; Budget</Text>
                    </HStack>

                    {/* Realisasi < Budget */}
                    <HStack spacing={2}>
                        <Box flexShrink={0} w="20px" display="flex" justifyContent="center" alignItems="center">
                            <Box
                                w="8px"
                                h="16px"
                                bg="gray.400"
                                borderRadius="8px 0 0 8px"
                                border="2px solid white"
                                boxShadow="sm"
                            />
                        </Box>
                        <Text fontSize="xs" color="gray.600">Realisasi &lt; Budget</Text>
                    </HStack>

                    {/* Kegiatan Referensi */}
                    <HStack spacing={2}>
                        <Box flexShrink={0} w="20px" display="flex" justifyContent="center" alignItems="center">
                            <Box
                                w="16px"
                                h="16px"
                                bg="gray.400"
                                style={{ clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)' }}
                            />
                        </Box>
                        <Text fontSize="xs" color="gray.600">Kegiatan Referensi</Text>
                    </HStack>
                </VStack>
            </Box>
        </Box>
    );
};

export default UpkeepMapLegend;
